import { createAction } from '@reduxjs/toolkit';
import * as commonActions from './action-types';
import * as commonActionUtils from './_action-utilities';
import { StateReset } from './action-types';

type ActionItem = {
  action: string;
};

const { AmplifyUIActions, CMxApplication } = commonActions;

const showConfirm = createAction<ActionItem>(AmplifyUIActions.SHOW_CONFIRM);
const dismissConfirm = createAction<ActionItem>(AmplifyUIActions.DISMISS_CONFIRM);
const handleConfirm = createAction<ActionItem>(AmplifyUIActions.HANDLE_CONFIRM);
const amplifyFeedback = createAction<AmplifyAPI.AmplifyFeedback>(AmplifyUIActions.AMPLIFY_FEEDBACK);
const hideFeedback = createAction<void>(AmplifyUIActions.HIDE_FEEDBACK);

const resetCommonState = createAction(StateReset.RESET_COMMON, () => ({
  payload: undefined as void,
  meta: { broadcast: true }
}));

const awaitingResources = createAction<boolean>(CMxApplication.AWAITING_RESOURCES);

const setStandaloneMode = createAction<void>(AmplifyUIActions.SET_STANDALONE_MODE);
const setAmplifyView = createAction<void>(AmplifyUIActions.SET_AMPLIFY_VIEW);
const setAutomateView = createAction<void>(AmplifyUIActions.SET_AUTOMATE_VIEW);

/**
 * Action creator for saving user's active service line to capability state
 * @param serviceLineName - The name of the service line to save
 */
const saveServiceLineCapability = createAction<string>(AmplifyUIActions.SAVE_SERVICE_LINE_CAPABILITY);

export const ANALYTICS_ACTION_METADATA = Object.freeze({ analytics: true });
const chooseContext = createAction(
  CMxApplication.CHOOSE_CONTEXT,
  (payload: CMxCommonApp.Context) => ({
    payload,
    meta: ANALYTICS_ACTION_METADATA
  })
);

export {
  awaitingResources,
  showConfirm,
  dismissConfirm,
  handleConfirm,
  amplifyFeedback,
  hideFeedback,
  resetCommonState,
  setStandaloneMode,
  setAmplifyView,
  setAutomateView,
  chooseContext,
  saveServiceLineCapability
};
